Postlogin = (function (postlogin) {
    postlogin.UserView = {};
    const self = postlogin.UserView;

    let email;

    // Ported from bootstrap-select to Tom Select 2026-05-12.
    // Tiny helper so the three init call sites below and the
    // programmatic .setValue() helper at the bottom of the file
    // share one shape.
    const initLicensePicker = (selector, options = {}) => {
        const el = document.querySelector(selector);
        if (!el) return;
        // eslint-disable-next-line no-new
        new TomSelect(el, {
            plugins: ['remove_button'],
            diacritics: true,
            maxOptions: null,
            ...options,
        });
    };

    self.init = function () {
        // Main license (single-select, visible at page load).
        initLicensePicker('#licenses');

        // Visible placeholder for additional licenses at page load.
        initLicensePicker('#license-display');

        // Editable additional licenses dropdown (hidden until edit).
        initLicensePicker('#additional-licenses');

        new self.View();
    };

    // Tom Select's .setValue replaces bootstrap-select's
    // .selectpicker('val', arr): it updates both the native
    // <select>.value AND the rendered chips in one call. Guard
    // against the element not being wrapped yet (e.g. tests that
    // don't go through init).
    const setLicensePickerValue = (selector, arr) => {
        const el = document.querySelector(selector);
        if (!el || !el.tomselect) {
            $(selector).val(arr);
            return;
        }
        el.tomselect.setValue(arr);
    };

    self.View = VjsUtility.Controller.extend({
        // holds the data before updating it for comparison purposes
        currentUserData: {},
        events: {
            'click .edit-section-btn': 'unlockSectionForEdit',
            'click .save-section-btn': 'saveSectionEdit',
            'click .save-field-btn': 'saveFieldEdit',
            'click .edit-field-btn': 'unlockFieldForEdit',
            'click .cancel-edit-btn': 'cancelSectionEdit',
            'click button#validate-email-btn': 'clickSendValidationEmail',
            'click button#delete-email-btn': 'deleteEmail',
            'click button#add-email-btn': 'enableEmailEdit',
            'click button#edit-email-btn': 'enableEmailEdit',
            'click button#cancel-email-edit-btn': 'cancelEmailEdit',
            'click button#save-email-btn': 'clickSaveEmail',
            'click button#login-as-user': 'generateLoginLink',
            'change #role': 'changeRole',
        },

        generateLoginLink(e) {
            e.preventDefault();

            const href = $(e.currentTarget).data('url');

            $('#login-as-modal .modal-body').html('...working...');
            $('#login-as-modal').modal('show');

            $.post(href, (data) => {
                const rawUrl = data.data.url;

                // Escaping alone isn't enough here: a "javascript:" (or other
                // non-http scheme) URL contains no HTML metacharacters for
                // _.escape() to touch, so it would still execute on click.
                // Require an http(s) scheme before this ever reaches the href.
                if (typeof rawUrl !== 'string' || !/^https?:\/\//i.test(rawUrl)) {
                    $('#login-as-modal .modal-body').html('<p>Unable to generate a login link. Please try again.</p>');
                    return;
                }

                // Build the markup as real DOM nodes (rather than an HTML
                // string handed to jQuery's .html()) so the URL never flows
                // through an HTML-parsing sink, regardless of the escaping
                // above.
                const paragraph = document.createElement('p');
                paragraph.textContent = 'Paste this link into a new incognito window:';

                const link = document.createElement('a');
                link.href = rawUrl;
                link.textContent = rawUrl;

                const input = document.createElement('input');
                input.type = 'text';
                input.style.width = '100%';
                input.value = rawUrl;

                $('#login-as-modal .modal-body').empty().append(paragraph, link, input);
            });

            return false;
        },

        changeRole(e) {
            e.preventDefault();
            const newRoleId = $(e.currentTarget).val();
            const gradeField = $('.info-field[data-field="grade"]');
            const additionLicensesField = $('.info-field[data-field="additional-licenses"]');
            const gradePlaceholder = $('[data-placeholder="grade"]');

            // If it's a student, show the grade field
            if (+newRoleId === 2) {
                gradeField.removeClass('hidden').addClass('editable');
                gradePlaceholder.addClass('hidden');
            } else {
                gradeField.addClass('hidden').removeClass('editable');
            }

            // If not a student, hide the grade field
            if (newRoleId > 3) {
                additionLicensesField.removeClass('hidden').addClass('editable');
            } else {
                additionLicensesField.addClass('hidden').removeClass('editable');
            }
        },

        unlockSectionForEdit(e) {
            e.preventDefault();

            this.toggleEditButtons(e);
            this.toggleEditSection(e);
            this.getCurrentUserData(e);
        },

        unlockEmailEdit(e) {
            e.preventDefault();

            this.getCurrentUserData(e);
            this.toggleEmailButtons(e);
        },

        saveSectionEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.saveCurrentUserData(e);
        },

        saveFieldEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.saveCurrentUserData(e);
        },

        cancelSectionEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.toggleEditButtons(e);
            this.toggleEditSection(e);
            this.resetSectionEdits(e);
        },

        clearErrorFields() {
            $('.field-error').remove();
        },

        toggleEditButtons(e) {
            const editButton = $(e.currentTarget);
            const saveCancelButtons = $(e.currentTarget).siblings('.btn');

            editButton.toggleClass('hidden');
            saveCancelButtons.toggleClass('hidden');
        },

        toggleEditSection(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFieldPlaceholders = section.find('.editable .profile-field');
            const editFields = section.find('.edit-field');

            editableFieldPlaceholders.toggleClass('hidden');
            editFields.toggleClass('hidden');

            $(section.find('.editable')).each((index, element) => {
                const field = $(element);
                if (field.hasClass('password-confirm')) {
                    field.toggleClass('hidden');
                }
            });
        },

        resetSectionEdits(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFields = section.find('.editable input.edit-field, .editable select.editable-select');

            editableFields.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');

                $(field).val(this.currentUserData[fieldName]);
            });
        },

        enableEmailEdit(e) {
            e.preventDefault();
            this.getCurrentUserData(e);

            const emailField = $('#email');
            const emailPlaceholder = $('.email-field .profile-field');
            const validateEmailBtn = $('#validate-email-btn');
            const deleteBtn = $('#delete-email-btn');
            const addEmailBtn = $('#add-email-btn');
            const editEmailBtn = $('#edit-email-btn');
            const saveBtn = $('#save-email-btn');
            const cancelBtn = $('#cancel-email-edit-btn');

            emailPlaceholder.addClass('hidden');
            emailField.removeClass('hidden');
            validateEmailBtn.addClass('hidden');
            deleteBtn.addClass('hidden');
            addEmailBtn.addClass('hidden');
            editEmailBtn.addClass('hidden');

            saveBtn.removeClass('hidden');
            cancelBtn.removeClass('hidden');
        },

        cancelEmailEdit(e) {
            e.preventDefault();

            const emailField = $('#email');
            const emailPlaceholder = $('.email-field .profile-field');
            const validateEmailBtn = $('#validate-email-btn');
            const deleteBtn = $('#delete-email-btn');
            const addEmailBtn = $('#add-email-btn');
            const editEmailBtn = $('#edit-email-btn');
            const saveBtn = $('#save-email-btn');
            const cancelBtn = $('#cancel-email-edit-btn');

            if (this.currentUserData.email !== '' && this.currentUserData.email) {
                emailPlaceholder.removeClass('hidden');
                editEmailBtn.removeClass('hidden');
                addEmailBtn.addClass('hidden');
                deleteBtn.removeClass('hidden');

                const validatedEmail = emailField.data('validated-email');

                // if the validated email does not match the current email then show the validate me button
                if (validatedEmail && validatedEmail !== this.currentUserData.email) {
                    validateEmailBtn.removeClass('hidden');
                } else {
                    validateEmailBtn.addClass('hidden');
                }
                if (!validatedEmail && this.currentUserData.email) {
                    validateEmailBtn.removeClass('hidden');
                }
            } else {
                editEmailBtn.addClass('hidden');
                addEmailBtn.removeClass('hidden');
                deleteBtn.addClass('hidden');
                validateEmailBtn.addClass('hidden');
            }

            emailField.addClass('hidden');
            saveBtn.addClass('hidden');
            cancelBtn.addClass('hidden');
        },

        deleteEmail(e) {
            e.preventDefault();

            this.clearErrorFields();

            // Set the input and the placeholder to be empty strings.
            $('#email').val('');
            $('.email-field').find('.profile-field').val('');

            // then do our own save email call instead of using saveCurrentUserData
            this.saveEmail('');
        },

        clickSaveEmail(e) {
            e.preventDefault();

            const emailAddress = $('#email');
            this.saveEmail(emailAddress.val());
        },

        saveEmail(emailAddress) {
            const saveRequest = new VjsUtility.Request();
            const saveUrl = $('#account-info').data('user-update');
            const userId = $('#account-info').data('user-id');

            saveRequest
                .post(saveUrl, {
                    email: emailAddress,
                    user_id: userId,
                })
                .done(() => {
                    const emailField = $('#email');
                    const validateEmailBtn = $('#validate-email-btn');
                    const deleteBtn = $('#delete-email-btn');
                    const addEmailBtn = $('#add-email-btn');
                    const editEmailBtn = $('#edit-email-btn');
                    const emailPlaceholder = $('.email-field .profile-field');
                    const saveBtn = $('#save-email-btn');
                    const cancelBtn = $('#cancel-email-edit-btn');

                    let notificationText = '';
                    saveBtn.addClass('hidden');
                    cancelBtn.addClass('hidden');
                    emailField.addClass('hidden');
                    emailPlaceholder.removeClass('hidden');

                    if (emailAddress !== '') {
                        notificationText = 'Email Saved!';

                        const currentValidatedEmail = emailField.data('validated-email');
                        const validated = currentValidatedEmail === emailAddress;
                        deleteBtn.removeClass('hidden');
                        editEmailBtn.removeClass('hidden');
                        addEmailBtn.addClass('hidden');

                        if (validated) {
                            validateEmailBtn.addClass('hidden');
                            emailPlaceholder.text(`${emailAddress} (Validated`);
                        } else {
                            validateEmailBtn.removeClass('hidden');
                            emailPlaceholder.text(`${emailAddress} (Not Validated)`);

                            this.sendValidationEmail();
                            notificationText += ' Sending Validation Email';
                        }
                    } else {
                        notificationText = 'Email Removed From Profile!';

                        validateEmailBtn.addClass('hidden');
                        deleteBtn.addClass('hidden');
                        editEmailBtn.addClass('hidden');
                        emailPlaceholder.text(emailAddress);
                        addEmailBtn.removeClass('hidden');
                    }

                    VjsUtility.Notification.success(notificationText);
                })
                .fail((fail) => {
                    // Fail condition is okay - it will show errors for any field that came back from validation
                    const failData = fail.responseJSON;
                    VjsUtility.Notification.error(failData.message);

                    _.forOwn(failData.data, (value, key) => {
                        const errorField = $(`[name="${key}"]`);
                        const fieldContainer = $(errorField).closest('.info-field');
                        const errorTemplate = `<span class="field-error">
                                ${value}
                            </span>`;

                        $(errorTemplate).insertAfter(fieldContainer);
                    });
                });
        },

        saveCurrentUserData(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFields = section.find('.editable input.edit-field, .editable select.editable-select');
            const profileData = {};
            const saveData = {};
            let isSectionEdit = true;

            editableFields.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');
                const fieldValue = field.val();

                if (field.closest('.info-field').hasClass('editable-field')) {
                    isSectionEdit = false;
                }

                profileData[fieldName] = fieldValue;
            });

            _.forOwn(profileData, (value, key) => {
                if (value !== this.currentUserData[key]) {
                    saveData[key] = value;
                }
            });

            // this will only save if something has changed - the saveData object has some properties we have added.
            const saveUrl = $('#account-info').data('user-update');
            const userId = $('#account-info').data('user-id');

            saveData.user_id = userId;
            if (Object.keys(saveData).length > 0) {
                const saveRequest = new VjsUtility.Request();
                saveRequest
                    .post(saveUrl, saveData)
                    .done(() => {
                        this.toggleEditButtons(e);
                        if (isSectionEdit) {
                            this.toggleEditSection(e);
                        } else {
                            this.toggleEditField(e);
                        }

                        const additionalLicensesPlaceholder = $('#license-display');
                        const additionalLicensesSelect = $('#additional-licenses');
                        const mainLicenseSelect = $('#licenses');
                        const mainLicense = mainLicenseSelect.find('option:selected').val();
                        const mainLicensePlaceholder = $('.profile-field[data-placeholder="license_id"]');

                        // since email is all by itself everything else can be checked here.
                        if (saveData.license_ids) {
                            // make sure the main licenses is part of the list that will be selected when rebuilding
                            const allSavedLicenses = saveData.license_ids;
                            allSavedLicenses.push(mainLicense);

                            // Assign array of licenses to both the
                            // editable picker and the visible
                            // placeholder. Tom Select's .setValue()
                            // updates both the native <select>.value
                            // and the rendered chips (the same way
                            // bootstrap-select's .selectpicker('val',
                            // arr) did before the port).
                            setLicensePickerValue('#additional-licenses', allSavedLicenses);
                            setLicensePickerValue('#license-display', allSavedLicenses);
                        }

                        if (saveData.license_id) {
                            const currentLicenses = additionalLicensesSelect.val();
                            currentLicenses.push(saveData.license_id);
                            setLicensePickerValue('#additional-licenses', currentLicenses);
                            setLicensePickerValue('#license-display', currentLicenses);

                            const mainLicenseName = mainLicenseSelect.find(`option[value="${mainLicenseSelect.val()}"]`).text();
                            mainLicensePlaceholder.text(mainLicenseName);
                        }

                        // this will set the placeholders with the exception of license and additional license
                        _.forOwn(saveData, (value, key) => {
                            if (key !== 'license_ids' && key !== 'license_id') {
                                let placeholderText = '';
                                placeholderText = key === 'role_id' ? $('#role').find(`option[value="${value}"]`).text() : value;

                                $(`[data-placeholder="${key}"`).text(placeholderText);
                            }
                        });

                        if (saveData.password || saveData.password_confirm) {
                            // Always clear out the password fields
                            $('#password, #confirm-password').val('');
                        }

                        VjsUtility.Notification.success('User Saved!');
                    })
                    .fail((fail) => {
                        const failData = fail.responseJSON;
                        VjsUtility.Notification.error(failData.message);

                        // if there's an error indicate the field with an error box
                        _.forOwn(failData.data, (value, key) => {
                            const errorField = $(`[name="${key}"]`);
                            const fieldContainer = $(errorField).closest('.info-field');

                            const errorTemplate = `<span class="field-error">
                                ${value}
                            </span>`;

                            $(errorTemplate).insertBefore(fieldContainer);
                        });

                        if (saveData.password || saveData.password_confirm) {
                            // Always clear out the password fields
                            $('#password, #confirm-password').val('');
                        }
                    });
            } else {
                this.toggleEditButtons(e);
                this.toggleEditSection(e);
            }
        },

        getCurrentUserData(e) {
            const section = $(e.currentTarget).closest('form');
            const currentValues = section.find('.editable input, .editable select');

            // this will cycle through any updatable field and adds them to the current data object for comparison
            currentValues.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');
                const fieldValue = field.val();

                if (fieldName === 'email' && !email) {
                    this.currentUserData.hasOriginalEmail = fieldValue && fieldValue !== '';
                }

                this.currentUserData[fieldName] = fieldValue;
            });
        },

        clickSendValidationEmail(e) {
            e.preventDefault();

            this.sendValidationEmail();
        },

        sendValidationEmail() {
            email = $('#email').val();

            if (Jr.Utils.validateEmail(email)) {
                const validationButton = $('#validate-email-btn');
                const license = validationButton.data('license');
                const userId = $('#account-info').data('user-id');
                const validationUrl = validationButton.data('validation-url');

                const sendValidation = new VjsUtility.Request();
                sendValidation
                    .post(validationUrl, { email, license, user_id: userId })
                    .done(() => {
                        const validateEmailBtn = $('.validate-email-btn');
                        validateEmailBtn.removeClass('btn-red').addClass('btn-blue');
                        validateEmailBtn
                            .text('Email sent!')
                            .off()
                            .on('click', (event) => {
                                event.preventDefault();
                            });

                        VjsUtility.Notification.success('Email Validation Sent');
                    })
                    .fail(() => {
                        VjsUtility.Notification.error('Email Validation Failed To Send');
                    });
            }
        },
    });

    return postlogin;
}(Postlogin || {}));
